import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import triggerAnalyticsEvent, { Analytics } from '../../helpers/analyticsMiddleware';
import { Stack } from 'syf-component-library/ui/spacing';
import { Body } from 'syf-component-library/ui/typography';
import { useSelector } from 'react-redux';
import { ErrorSource } from '../../redux/questionnaire/typings';
import Section from '../../ui/atoms/Section';
import { t } from '../../strings/i18n/i18n';
import ContentHeader from '../../ui/atoms/Header';
var PostQuestionnaireErrorScreen = function (_a) {
    var source = _a.source;
    return (_jsxs(Section, { children: [_jsx(ContentHeader, { content: "".concat(t('technicalError.title')) }), _jsx(Stack, { size: "medium" }), _jsx(Body, { children: t('technicalError.description') }), source === ErrorSource.PostCases && (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "large" }), _jsx(Body, { children: t('technicalError.callUs') })] }))] }));
};
var AuthenticationFailureScreen = function () {
    return (_jsxs(Section, { children: [_jsx(ContentHeader, { content: "".concat(t('technicalError.apologize')) }), _jsx(Stack, { size: "medium" }), _jsx(Body, { children: t('technicalError.authFailure') }), _jsx(Stack, { size: "large" }), _jsx(Body, { children: t('technicalError.tryAgain') })] }));
};
var TechnicalError = function () {
    var source = useSelector(function (state) { return state; }).questionnaire.businessError.source;
    useEffect(function () {
        triggerAnalyticsEvent({
            PageKind: Analytics.Dispute,
            PageFunction: Analytics.Billing,
            PageSubFunction: Analytics.Form,
            pageName: Analytics.Sorry
        });
    }, []);
    return source === ErrorSource.Authentication ? (_jsx(AuthenticationFailureScreen, {})) : (_jsx(PostQuestionnaireErrorScreen, { source: source }));
};
export default TechnicalError;
//# sourceMappingURL=index.js.map